
import React, { useState, useRef, useEffect } from 'react';

const AcademicChoosing= () => {
  const ChoosingData = [
    {
      heading: "Affordability",
      description: "We offer competitive pricing plans for academic writing services, ensuring accessibility and affordability for MBA students on a tight budget.",
    },
    {
      heading: "Quality and Originality",
      description: "Despite offering cheap solutions, we never compromise on quality or originality. Our team of experienced writers delivers well-researched, original, and professionally written assignments that meet academic standards and requirements.",
    },
    {
      heading: "Timeliness and Reliability: ",
      description: "We prioritize timeliness and reliability in delivering academic writing services, ensuring that MBA students receive their assignments on time, every time, without delays or excuses.",
    },
    {
      heading: "Customer Support",
      description: "We provide dedicated customer support to assist MBA students with any questions, concerns, or inquiries related to our academic writing services, ensuring prompt and satisfactory resolution.",
    }
  ];

  return (
    <div  className="col-lg-6">
    <div className="accordions-new is-first-expanded">
      {ChoosingData.map((item, index) => (
        <AccordionItem key={index} title={item.heading} content={item.description} />
      ))}
    </div>
    </div>
  );
};

const AccordionItem = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (contentRef.current) {
      if (isOpen) {
        contentRef.current.style.maxHeight = contentRef.current.scrollHeight + 'px';
      } else {
        contentRef.current.style.maxHeight = '0px';
      }
    }
  }, [isOpen]);

  return (
    <article className="accordion">
      <div className="accordion-head" onClick={toggleAccordion}>
        <span>{title}</span>
        <span className={`icon ${isOpen ? 'open' : ''}`}>
          <i className={`fa ${isOpen ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
        </span>
      </div>
      <div
        ref={contentRef}
        className={`accordion-body ${isOpen ? 'open' : ''}`}
        style={{ maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : '0px' }}
      >
        <div className="content">
          <p>{content}</p>
        </div>
      </div>
    </article>
  );
};

export default AcademicChoosing;
